// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/cf-radar-assistance.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/cf-radar-assistance/cf-radar-assistance.js';

mount([g0]);
